// no conflict
var $ = jQuery.noConflict();

$(document).ready(function () {
	//Trigger AOS
	AOS.init({
		duration: 4000,
		easing: "ease-in-out",
		once: true,
		mirror: false,
		disable: window.innerWidth < 768,
	});

	// Sticky nav scroll logic
	$(window).on("scroll", function () {
		var sc = $(window).scrollTop();
		if (sc > 100) {
			$("#header").addClass("sticky-nav");
		} else {
			$("#header").removeClass("sticky-nav");
		}
	});

	// Run on page load (in case user refreshed at a scroll position)
	$(document).ready(function () {
		var sc = $(window).scrollTop();
		if (sc > 100) {
			$("#header").addClass("sticky-nav");
		}
	});

	// ✅ OPEN MODAL
	$("[data-modal-target]").on("click", function (e) {
		e.preventDefault();
		var modalId = $(this).data("modal-target");
		var $modal = $("#" + modalId);
		if ($modal.length) {
			$modal.removeClass("hidden");
		}
	});

	// ✅ CLOSE MODAL and stop media
	$(".closeModal").on("click", function () {
		var $modal = $(this).closest(".fixed");
		if ($modal.length) {
			$modal.addClass("hidden");

			// Pause <video> elements inside the modal
			$modal.find("video").each(function () {
				this.pause();
				this.currentTime = 0; // Optional: reset to beginning
			});

			// Stop <iframe> playback (e.g., YouTube) by resetting src
			$modal.find("iframe").each(function () {
				var $iframe = $(this);
				var src = $iframe.attr("src");
				$iframe.attr("src", src); // Reassign to stop playback
			});
		}
	});
});
